<template>
  <!-- Footer -->
  <div style="display: flex; justify-content: space-between; align-items: center; gap: 20px; padding: 20px; background-color: #001F5A; margin-top: 50px">
    <div style="flex: 1; display: flex;">
      <img :src="broadridge_footer" alt="Broadridge Logo"
           style="max-width: 200px;">
    </div>
    <div style="flex: 1; font-size: 16px; font-weight: 400; color: white">
      <p style="text-align: left">Broadridge is a global technology leader with trusted expertise and transformative
        technology, helping our
        clients and the financial services industry operate, innovate, and grow. We power investing, governance, and
        communications for our clients – driving operational resilience, elevating business performance, and
        transforming investor experiences.</p>
      <p style="text-align: right">© {{ currentYear }} Broadridge Financial Solutions, Inc.<br>All Rights Reserved.</p>
      <div style="display: flex; gap: 32px; justify-content: flex-end; flex-direction: row">
        <a href="https://www.linkedin.com/company/broadridge-financial-solutions/" target="_blank" rel="noreferrer">
          <img :src="linkedin" alt="linkedin">
        </a>
        <a href="https://instagram.com/broadridge " target="_blank" rel="noreferrer">
          <img :src="instagram" alt="Instagram">
        </a>
        <a href="https://www.youtube.com/broadridge" target="_blank" rel="noreferrer">
          <img :src="youtube" alt="Youtube">
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import broadridge_footer from '@/assets/broadridge_footer.webp';
import linkedin from '@/assets/linkedIn.png';
import instagram from '@/assets/instagram.png';
import youtube from '@/assets/youTube.png';

</script>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
